import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withLastLocation } from 'react-router-last-location';
import PropTypes from 'prop-types';

import './styles.css';

import arrow from './img/arrow.svg';

class BackButton extends Component {
  constructor(props) {
    super(props);

    this.onOver = this.onOver.bind(this);
    this.onOut = this.onOut.bind(this);
    this.goBack = this.goBack.bind(this);

    this.state = {
      hover: false,
    };
  }

  componentDidMount() {
    this.button.addEventListener('mouseover', this.onOver);
    this.button.addEventListener('mouseout', this.onOut);
    if ('ontouchstart' in window) {
      this.button.addEventListener('touchstart', this.onOver);
      this.button.addEventListener('touchend', this.onOut);
    }
  }

  componentWillUnmount() {
    this.button.removeEventListener('mouseover', this.onOver);
    this.button.removeEventListener('mouseout', this.onOut);
    if ('ontouchstart' in window) {
      this.button.removeEventListener('touchstart', this.onOver);
      this.button.removeEventListener('touchend', this.onOut);
    }
  }

  onOver() {
    this.setState({
      hover: true,
    });
  }

  onOut() {
    this.setState({
      hover: false,
    });
  }

  goBack(e) {
    e.preventDefault();
    this.context.router.history.goBack();
  }

  render() {
    let className = 'back-button';

    if (this.props.className) className += ` ${this.props.className}`;
    if (this.state.hover) className += ' back-button--hover';

    let { onClick } = this.props;

    // check if href === the last location
    if (this.props.lastLocation !== null &&
        this.props.onClick !== false &&
       (this.props.lastLocation.pathname === this.props.href ||
       (this.props.lastLocation.pathname === '/' && this.props.href === false))) {
      onClick = this.goBack;
    }

    return (
      <div ref={(button) => { this.button = button; }} className={className}>
        <Link className="back-button__link" to={this.props.href} onClick={onClick}>
          <span className="back-button__holder">
            <img className="back-button__img" src={arrow} width="18" height="14" alt="Back" />
          </span>
        </Link>
      </div>
    );
  }
}

BackButton.contextTypes = {
  router: PropTypes.object,
};

BackButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  lastLocation: PropTypes.object,
  href: PropTypes.string,
};

BackButton.defaultProps = {
  className: '',
  onClick: null,
  lastLocation: null,
  href: '',
};

export default withLastLocation(BackButton);



// WEBPACK FOOTER //
// ./src/components/BackButton/index.jsx